import { DottedBox, FoodsIcon } from "@foodpilot/foods";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type NoGoalsProps = {
    addOneGoal: () => void;
};
export const NoGoals = (props: NoGoalsProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <DottedBox>
            <Stack
                flexDirection={"row"}
                padding={theme.spacing(2)}
                justifyContent={"space-between"}
                alignItems={"center"}
            >
                <Typography variant="h5">{t("actionPlan.trajectory.form.goal.noItem")}</Typography>
                <Button variant="text" startIcon={<FoodsIcon size={2} icon="plus" />} onClick={props.addOneGoal}>
                    {t("actionPlan.trajectory.form.addGoal")}
                </Button>
            </Stack>
        </DottedBox>
    );
};
